import { createFileRoute } from "@tanstack/react-router";
import { useMutation } from "@tanstack/react-query";
import { useEffect } from "react";
import { crmConfirmarContrato } from "@/server/crm/promotores.fns";

export const Route = createFileRoute("/confirmar-contrato")({
  validateSearch: (search) => ({ token: typeof search.token === "string" ? search.token : "" }),
  component: ConfirmarContratoPage,
});

function ConfirmarContratoPage() {
  const { token } = Route.useSearch();
  const mutation = useMutation({
    mutationFn: () => crmConfirmarContrato({ data: { token } }),
  });

  useEffect(() => {
    if (token) mutation.mutate();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token]);

  return (
    <main className="min-h-screen bg-gray-50 flex items-center justify-center p-6">
      <div className="w-full max-w-md bg-white border rounded-lg p-6 space-y-3">
        <h1 className="text-xl font-semibold text-gray-900">Confirmación de contrato</h1>
        {!token ? (
          <p className="text-sm text-red-600">El enlace no contiene un token válido.</p>
        ) : mutation.isPending ? (
          <p className="text-sm text-gray-500">Confirmando participación...</p>
        ) : mutation.isError ? (
          <p className="text-sm text-red-600">{(mutation.error as Error).message}</p>
        ) : mutation.data ? (
          <div className="space-y-2">
            <p className="text-sm text-green-700">Participación confirmada correctamente.</p>
            <p className="text-sm text-gray-600">
              {mutation.data.promotor?.nombre ?? "Promotor"} ·{" "}
              {mutation.data.evento?.nombre ?? "Evento"}
            </p>
          </div>
        ) : null}
      </div>
    </main>
  );
}
